import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { DomainDesignation } from "@constants";
export default {
  props: {
    domain: {
      type: Object,
      default() {
        return {};
      }
    },
    facts: {
      type: Array,
      default() {
        return [];
      }
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      designation: {}
    };
  },
  mounted() {
    this.setTheme();
  },
  computed: {
    ineligibilityReason() {
      let target = this.facts.find(x => x.IneligibilityReasonId);
      return target && this.facts.length === this.facts.filter(x => x.IneligibilityReasonId).length ? this.$store.state.ineligibilityReasons.find(x => x.IneligibilityReasonId === target.IneligibilityReasonId) : null;
    }
  },
  watch: {
    facts() {
      this.setTheme();
    }
  },
  methods: {
    setTheme() {
      this.designation = DomainDesignation.getDesignation(this.facts, this.domain);
    }
  }
};